import { z } from "zod";

export const downloadStatusSchema = z.object({
  status: z.boolean(),
  url: z.string().nullable(),
  error: z.enum(["RESUME_LAYOUT_OVERFLOW", "RESUME_PRINT_FAILED"]).optional(),
});

export type DownloadStatusDto = z.infer<typeof downloadStatusSchema>;
